import { SidebarHeader } from "./SidebarHeader";
import { SidebarNav } from "./SidebarNav";

export function Sidebar({
  collapsed = false,
  isCollapsed = false,
  onToggleCollapse,
  onNavigate,
  onRequestPayment,
  onAction,
}) {
  return (
    <div className="flex grow flex-col overflow-y-auto overflow-x-hidden border-r border-zinc-200 bg-zinc-50">
      <SidebarHeader
        collapsed={collapsed}
        isCollapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
        onNavigate={onNavigate}
      />
      <SidebarNav
        collapsed={collapsed}
        onNavigate={onNavigate}
        onRequestPayment={onRequestPayment}
        onAction={onAction}
      />
    </div>
  );
}
